import { EventCategory, GetIdeaResponse } from '@orbit/api-types'
import React from 'react'
import { getCategoryOptions, getLocationOptions } from '../ideaFilters'
import { FilterDropdown, FilterRow } from './IdeaGrid.styles'

interface IdeaFilterRowProps {
	/** The unfiltered set — the dropdown options derive from it, not from the visible subset. */
	ideas: GetIdeaResponse[]
	category: EventCategory | null
	location: string | null
	onCategoryChange: (category: EventCategory | null) => void
	onLocationChange: (location: string | null) => void
}

/** The Dropdown's "all" choice — null on the filter, an empty value on the wire. */
const ALL = ''

/**
 * The category + location dropdowns above an idea grid, on the app's
 * Dropdown. Options come from the ideas themselves (only categories/locations
 * actually in use), so the row is identical on the member and public
 * surfaces. The location dropdown hides when no idea carries a location.
 */
const IdeaFilterRow: React.FC<IdeaFilterRowProps> = ({
	ideas,
	category,
	location,
	onCategoryChange,
	onLocationChange,
}) => {
	const categoryOptions = [
		{ value: ALL, label: 'All categories' },
		...getCategoryOptions(ideas).map(option => ({ value: option.value as string, label: option.label })),
	]
	const locationOptions = [
		{ value: ALL, label: 'All locations' },
		...getLocationOptions(ideas).map(label => ({ value: label, label })),
	]

	return (
		<FilterRow>
			<FilterDropdown
				aria-label="Filter by category"
				options={categoryOptions}
				value={category ?? ALL}
				onChange={value => onCategoryChange(value === ALL ? null : (value as EventCategory))}
			/>
			{locationOptions.length > 1 && (
				<FilterDropdown
					aria-label="Filter by location"
					options={locationOptions}
					value={location ?? ALL}
					onChange={value => onLocationChange(value === ALL ? null : value)}
				/>
			)}
		</FilterRow>
	)
}

export default IdeaFilterRow
